import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';

import {PipesModule} from '@pipes/Pipes.module';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {ModalModule} from 'ngx-bootstrap/modal';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AngularMyDatePickerModule} from 'angular-mydatepicker';
import {TextMaskModule} from 'angular2-text-mask';
import {TranslateModule} from '@ngx-translate/core';
import {NgbTimepickerModule} from '@ng-bootstrap/ng-bootstrap';
import { ColorPickerModule } from 'ngx-color-picker';

import {PathPantallaComponent} from '@componentes/PathPantalla/PathPantalla.component';
import {InputComponent} from '@componentes/Input/Input.component';
import {CorreoComponent} from '@componentes/Correo/Correo.component';
import {TextareaComponent} from '@componentes/Textarea/Textarea.component';
import {DropdownComponent} from '@componentes/Dropdown/Dropdown.component';
import {CheckBoxComponent} from '@componentes/CheckBox/CheckBox.component';
//import {DatePickerComponent} from '@componentes/DatePicker/DatePicker.component';
import {DatePickerV2Component} from '@componentes/DatePickerV2/DatePickerV2.component';
import {TimePickerComponent} from '@componentes/TimePicker/TimePicker.component';
import {FileComponent} from '@componentes/File/File.component';
import {IconoComponent} from '@componentes/Icono/Icono.component';
import {ColorPickerComponent} from '@componentes/ColorPicker/ColorPicker.component';

import {TokenComponent} from '@componentes/Token/Token.component';
import {FiltrosComponent} from '@componentes/Filtros/Filtros.component';
import {MultiSelectComponent} from '@componentes/MultiSelect/MultiSelect.component';
import { RadioButtonComponent } from './RadioButton/radiobutton.component';
import { ImagenVisualizadorComponent } from './ImagenVisualizador/ImagenVisualizador.component';
import { ImagenCompletaComponent } from './ImagenVisualizador/ImagenCompleta/ImagenCompleta.component';
import { DxTreeViewModule } from 'devextreme-angular';
import { MultiSelectTreeViewComponent } from './MultiSelectTreeView/MultiSelectTreeView.component';

@NgModule({
    imports:
        [
            CommonModule,
            AngularSvgIconModule.forRoot(),
            FormsModule,
            AngularMyDatePickerModule,
            ReactiveFormsModule,
            PipesModule,
            TextMaskModule,
            ModalModule,
            TranslateModule,
            DxTreeViewModule,
            NgbTimepickerModule,
            ColorPickerModule
        ],
    declarations:
        [
            PathPantallaComponent,
            InputComponent,
            CorreoComponent,
            TextareaComponent,
            DropdownComponent,
            MultiSelectComponent,
            CheckBoxComponent,
            //DatePickerComponent,
            DatePickerV2Component,
            FileComponent,
            IconoComponent,
            ColorPickerComponent,
            TokenComponent,
            TimePickerComponent,
            FiltrosComponent,
            RadioButtonComponent,
            ImagenVisualizadorComponent,
            ImagenCompletaComponent,
            MultiSelectTreeViewComponent,
        ],

    exports:
        [
            PathPantallaComponent,
            InputComponent,
            CorreoComponent,
            TextareaComponent,
            DropdownComponent,
            MultiSelectComponent,
            CheckBoxComponent,
            //DatePickerComponent,
            DatePickerV2Component,
            FileComponent,
            IconoComponent,
            ColorPickerComponent,
            TokenComponent,
            TimePickerComponent,
            FiltrosComponent,
            RadioButtonComponent,
            ImagenVisualizadorComponent,
            ImagenCompletaComponent,
            MultiSelectTreeViewComponent
        ],
    entryComponents: [
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})

export class ComponentesModule {
}
